import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum bulkCustomerCicReportingType {
    UPLOAD_BULK_CUSTOMER_CIC_REPORTING = "@@auth/UPLOAD_BULK_CUSTOMER_CIC_REPORTING",
    UPLOAD_BULK_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/UPLOAD_BULK_CUSTOMER_CIC_REPORTING_SUCCESS",
    UPLOAD_BULK_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/UPLOAD_BULK_CUSTOMER_CIC_REPORTING_ERROR",
    RESET_UPLOAD_BULK_CUSTOMER_CIC_REPORTING = "@@auth/RESET_UPLOAD_BULK_CUSTOMER_CIC_REPORTING",

    FETCH_BULK_CUSTOMER_CIC_REPORTING = "@@auth/FETCH_BULK_CUSTOMER_CIC_REPORTING",
    FETCH_BULK_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/FETCH_BULK_CUSTOMER_CIC_REPORTING_SUCCESS",
    FETCH_BULK_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/FETCH_BULK_CUSTOMER_CIC_REPORTING_ERROR",
    RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING = "@@auth/RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING",

    FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL = "@@auth/FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL",
    FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_SUCCESS = "@@auth/FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_SUCCESS",
    FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_ERROR = "@@auth/FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_ERROR",
    RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL = "@@auth/RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL",

    BULK_CUSTOMER_CIC_REPORTING_VERSION = "@@auth/BULK_CUSTOMER_CIC_REPORTING_VERSION",
    BULK_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS = "@@auth/BULK_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS",
    BULK_CUSTOMER_CIC_REPORTING_VERSION_ERROR = "@@auth/BULK_CUSTOMER_CIC_REPORTING_VERSION_ERROR",
    RESET_BULK_CUSTOMER_CIC_REPORTING_VERSION = "@@auth/RESET_BULK_CUSTOMER_CIC_REPORTING_VERSION",

    BULK_CUSTOMER_CIC_REPORTING_PUBLISH = "@@auth/BULK_CUSTOMER_CIC_REPORTING_PUBLISH",
    BULK_CUSTOMER_CIC_REPORTING_PUBLISH_SUCCESS = "@@auth/BULK_CUSTOMER_CIC_REPORTING_PUBLISH_SUCCESS",
    BULK_CUSTOMER_CIC_REPORTING_PUBLISH_ERROR = "@@auth/BULK_CUSTOMER_CIC_REPORTING_PUBLISH_ERROR",
    RESET_BULK_CUSTOMER_CIC_REPORTING_PUBLISH = "@@auth/RESET_BULK_CUSTOMER_CIC_REPORTING_PUBLISH",

    BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD = "@@auth/BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD",
    BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_SUCCESS = "@@auth/BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_SUCCESS",
    BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_ERROR = "@@auth/BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_ERROR",
    RESET_BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD = "@@auth/RESET_BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD",

    FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING = "@@auth/FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING",
    FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_SUCCESS",
    FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_ERROR",
    RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING = "@@auth/RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING",

    APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE = "@@auth/APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE",
    APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS = "@@auth/APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS",
    APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR = "@@auth/APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR",
    RESET_APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE = "@@auth/RESET_APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE",

    REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE = "@@auth/REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE",
    REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS = "@@auth/REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS",
    REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR = "@@auth/REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR",
    RESET_REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE = "@@auth/RESET_REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE",

    DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE = "@@auth/DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE",
    DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS = "@@auth/DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS",
    DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR = "@@auth/DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR",
    RESET_DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE = "@@auth/RESET_DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE",
}

export type BulkCustomerCicReportingAction = {
    type:
        | bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.RESET_UPLOAD_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL
        | bulkCustomerCicReportingType.RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION
        | bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_VERSION
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH
        | bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_PUBLISH
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD
        | bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD
        | bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.RESET_APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.RESET_REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.RESET_DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE;
    payload: any;
};

export type uploadBulkCustomerCicReportingFile = {
    bulkCustomerCicReportingFile: File;
};

export type BulkCustomerCicReportingDetail = {
    externalID: string;
    internalID: string;
};

export type BulkCustomerCicReportingVersionType = {
    id: any;
    filter: FilterMetadata;
};

export type BulkCustomerCicReportingFileMakerRemarkType = {
    remarkPayload: { makerRemarks: string };
    externalId: string;
};

export type BulkCustomerCicReportingFileCheckerRemarkType = {
    remarkPayload: { checkerRemarks: string };
    externalId: string;
};

export type BulkCustomerCicReportingDownloadFileType = {
    downloadURL: string;
};

// Saga Types

export type uploadBulkCustomerCicReportingFileSaga = {
    type: string;
    payload: uploadBulkCustomerCicReportingFile;
};

export type fetchBulkCustomerCicReportingSaga = {
    type: string;
    payload: FilterMetadata;
};

export type fetchBulkCustomerCicReportingDetailSaga = {
    type: string;
    payload: BulkCustomerCicReportingDetail;
};

export type BulkCustomerCicReportingVersionSaga = {
    type: string;
    payload: BulkCustomerCicReportingVersionType;
};

export type BulkCustomerCicReportingFileMakerRemarkSaga = {
    type: string;
    payload: BulkCustomerCicReportingFileMakerRemarkType;
};

export type BulkCustomerCicReportingFileCheckerRemarkSaga = {
    type: string;
    payload: BulkCustomerCicReportingFileCheckerRemarkType;
};

export type BulkCustomerCicReportingDownloadSaga = {
    type: string;
    payload: BulkCustomerCicReportingDownloadFileType;
};

type reducerPayload = {
    data: FetchApiResponse<any>;
    error: string;
};

export type BulkCustomerCicReportingReducer = {
    type:
        | bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING_SUCCESS
        | bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING_ERROR
        | bulkCustomerCicReportingType.RESET_UPLOAD_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_SUCCESS
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_ERROR
        | bulkCustomerCicReportingType.RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_SUCCESS
        | bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_ERROR
        | bulkCustomerCicReportingType.RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION_ERROR
        | bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_VERSION
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH_SUCCESS
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH_ERROR
        | bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_PUBLISH
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_SUCCESS
        | bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_ERROR
        | bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD
        | bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_SUCCESS
        | bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_ERROR
        | bulkCustomerCicReportingType.RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING
        | bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS
        | bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR
        | bulkCustomerCicReportingType.RESET_APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS
        | bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR
        | bulkCustomerCicReportingType.RESET_REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE
        | bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS
        | bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR
        | bulkCustomerCicReportingType.RESET_DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE;
    payload: reducerPayload;
};

export type BulkCustomerCicReportingReducerStateWithoutListObject = {
    loading?: boolean;
    data?: CreateApiResponse<any>;
    error?: string | null;
};

export type BulkCustomerCicReportingReducerStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<any>;
    error?: string | null;
};
